import { STM } from '../context/types'

export const en_enStatements : STM[] = [
    {
        id: 1,
        valueKey: 'samen1',
        title: 'Working together is frequent',
        title_360_leadership: "stimulates teamwork",
        title_360_workenv: 'working together is frequent',
        preferredType: 'leadership',
    },
    {
        id: 2,
        valueKey: 'samen2',
        title: 'Team interests come before individual interests',
        title_360_leadership:
            "puts teams success before his own",
        title_360_workenv: "team interests come before individual interests",
        preferredType: 'workenv',
    },
    {
        id: 3,
        valueKey: 'samen3',
        title: 'One does his/her best for the team',
        title_360_leadership: "is involved with his team",
        title_360_workenv: 'one does his/her best for the team',
        preferredType: 'leadership',
    },
    {
        id: 4,
        valueKey: 'conf1',
        title: 'A personal opinion is not shared if this might lead to conflict',
        title_360_leadership:
            "does not express his opinion if it could lead to a conflict",
        title_360_workenv:
            "a personal opinion is not shared if this might lead to conflict",
        preferredType: 'workenv',
    },
    {
        id: 5,
        valueKey: 'conf2',
        title: 'Every effort is made to keep the peace',
        title_360_leadership: 'does everything to avoid disputes',
        title_360_workenv: 'every effort is made to keep the peace',
        preferredType: 'leadership',
    },
    {
        id: 6,
        valueKey: 'conf3',
        title: 'The existing rules and standards are followed precisely',
        title_360_leadership:
            "ensures that we respect the rules and norms",
        title_360_workenv: 'the existing rules and standards are followed precisely',
        preferredType: 'workenv',
    },
    {
        id: 7,
        valueKey: 'erken1',
        title: 'People are respected by co-workers and managers',
        title_360_leadership:
            'guarantees an environment where we respect each other',
        title_360_workenv: 'people are respected by co-workers and managers',
        preferredType: 'workenv',
    },
    {
        id: 8,
        valueKey: 'erken2',
        title: 'Recognition is given for hard work',
        title_360_leadership: "gives recognition for what we do",
        title_360_workenv: "recognition is given for hard work",
        preferredType: 'workenv',
    },
    {
        id: 9,
        valueKey: 'erken3',
        title: 'Commitment is valued and appreciated',
        title_360_leadership: "values the effort put in",
        title_360_workenv: "commitment is valued and appreciated",
        preferredType: 'leadership',
    },
    {
        id: 10,
        valueKey: 'zorg1',
        title: 'One always does right by others',
        title_360_leadership: 'is kind and respectful',
        title_360_workenv: 'one always does right by others',
        preferredType: 'leadership',
    },
    {
        id: 11,
        valueKey: 'zorg2',
        title: 'One contributes to the well-being of others',
        title_360_leadership: 'favors an atmosphere where everyone feels well',
        title_360_workenv: 'one contributes to the well-being of others',
        preferredType: 'workenv',
    },
    {
        id: 12,
        valueKey: 'zorg3',
        title: 'People help one another',
        title_360_leadership: "favors a climate of mutual support",
        title_360_workenv:
            "people help one another",
        preferredType: 'leadership',
    },
    {
        id: 13,
        valueKey: 'gelijk1',
        title: 'Everyone is treated equally',
        title_360_leadership: 'treats everyone fairly',
        title_360_workenv: 'everyone is treated equally',
        preferredType: 'workenv',
    },
    {
        id: 14,
        valueKey: 'gelijk2',
        title: 'Age, origin, or gender doesn’t matter',
        title_360_leadership:
            'does not make differences based on age, origin, or gender',
        title_360_workenv:
            'age, origin, or gender doesn’t matter',
        preferredType: 'workenv',
    },
    {
        id: 15,
        valueKey: 'gelijk3',
        title: 'One is judged by his/her actions, not by his/her character',
        title_360_leadership: 'evaluates us based on our actions',
        title_360_workenv:
            'one is judged by his/her actions, not by his/her character',
        preferredType: 'leadership',
    },
    {
        id: 16,
        valueKey: 'zelfsturing1',
        title: 'It is possible, for the most part, to act on your own',
        title_360_leadership:
            "lets me act on my own",
        title_360_workenv:
            "it is possible, for the most part, to act on your own",
        preferredType: 'workenv',
    },
    {
        id: 17,
        valueKey: 'zelfsturing2',
        title: 'One can determine his/her own method of work',
         title_360_leadership:
            'lets me determine my own way of working',
        title_360_workenv: 'one can determine his/her own method of work',
        preferredType: 'leadership',
    },
    {
        id: 18,
        valueKey: 'zelfsturing3',
        title: "One can plan oneself how to do one's work",
        title_360_leadership:
            'allows me to determine my own schedule',
        title_360_workenv: "one can plan oneself how to do one's work",
        preferredType: 'workenv',
    },
    {
        id: 19,
        valueKey: 'macht1',
        title: 'I can influence the behavior of others',
        title_360_leadership: 'influences my work',
        preferredType: 'leadership', // FIXME was leadership
    },
    {
        id: 20,
        valueKey: 'macht2',
        title: 'I am the one who decides on the things to be done',
        title_360_leadership: 'says what needs to be done',
        preferredType: 'leadership', // FIXME was leadership
    },
    {
        id: 21,
        valueKey: 'macht3',
        title: 'I determine what happens',
        title_360_leadership: 'determines what needs to be done',
        preferredType: 'disabled',// FIXME not disabled?
    },
    {
        id: 22,
        valueKey: 'voorspelbaar1',
        title: 'There is structure and regularity',
        title_360_leadership: 'encourages structure and regularity',
        title_360_workenv: 'there is structure and regularity',
        preferredType: 'workenv',
    },
    {
        id: 23,
        valueKey: 'voorspelbaar2',
        title: 'Things usually occur as planned',
        title_360_leadership:
            "ensures that things generally unfold as planned",
        title_360_workenv: 'things usually occur as planned',
        preferredType: 'leadership',
    },
    {
        id: 24,
        valueKey: 'voorspelbaar3',
        title: 'Traditional values and ways of thinking can be maintained',
         title_360_leadership:
            'guarantees respect for tradition (values, thoughts, customs)',
        title_360_workenv:
            'traditional values and ways of thinking can be maintained',
        preferredType: 'workenv',
    },
    {
        id: 25,
        valueKey: 'prestatie1',
        title: "It's possible to do one's best",
        title_360_leadership: 'encourages us to give our best',
        title_360_workenv: "it's possible to do one's best",
        preferredType: 'leadership',
    },
    {
        id: 26,
        valueKey: 'prestatie2',
        title: 'One can demonstrate his/her full potential',
         title_360_leadership: "encourages us to show what we can do",
        title_360_workenv: 'one can demonstrate his/her full potential',
        preferredType: 'workenv',
    },
    {
        id: 27,
        valueKey: 'prestatie3',
        title: 'One can excel in his/her work',
        title_360_leadership: "encourages us to excel in what we do",
        title_360_workenv: "one can excel in his/her work",
        preferredType: 'workenv',
    },
    {
        id: 28,
        valueKey: 'zelfontplooi1',
        title: 'One can continuously learn new things',
        title_360_leadership: 'encourages continuous learning',
        title_360_workenv: 'one can continuously learn new things',
        preferredType: 'workenv',
    },
    {
        id: 29,
        valueKey: 'zelfontplooi2',
        title: 'One can deepen his/her knowledge',
         title_360_leadership: 'encourages us to deepen our skills',
        title_360_workenv: 'one can deepen his/her knowledge',
        preferredType: 'leadership',
    },
    {
        id: 30,
        valueKey: 'zelfontplooi3',
        title: 'One can continuously expand his/her personal development',
        title_360_leadership: 'helps others develop',
        title_360_workenv: 'one can continuously expand his/her personal development',
        preferredType: 'workenv',
    },
    {
        id: 31,
        valueKey: 'duurzaam1',
        title: 'Good quality work is delivered',
        title_360_leadership:
            "ensures that the team delivers quality work",
        title_360_workenv: 'good quality work is delivered',
        preferredType: 'leadership',
    },
    {
        id: 32,
        valueKey: 'duurzaam2',
        title: 'Customers and/or others in the business are respected',
        title_360_leadership:
            "encourages the team to respect clients and other relationships",
        title_360_workenv: 'customers and/or others in the business are respected',
        preferredType: 'workenv',
    },
    {
        id: 33,
        valueKey: 'duurzaam3',
        title: 'One has consideration for people, safety and environment',
        title_360_leadership:
            "ensures that we take into account the individual, safety and environment",
        title_360_workenv:
            'one has consideration for people, safety and environment',
        preferredType: 'workenv',
    },
    {
        id: 34,
        valueKey: 'integriteit1',
        title: "Responsibility is taken for one's actions",
        title_360_leadership:
            "ensures that we take responsibility for our actions",
        title_360_workenv: "responsibility is taken for one's actions",
        preferredType: 'workenv',
    },
    {
        id: 35,
        valueKey: 'integriteit2',
        title: 'People are honest',
        title_360_leadership: 'is honest',
        title_360_workenv: 'people are honest',
        preferredType: 'workenv',
    },
    {
        id: 36,
        valueKey: 'integriteit3',
        title: 'Confidentiality is respected',
        title_360_leadership:
            "handles personal and confidential information with care",
        title_360_workenv:
            'confidentiality is respected',
        preferredType: 'leadership',
    },
    {
        id: 37,
        valueKey: 'innovatie1',
        title: 'New things can be tried',
        title_360_leadership:
            'encourages us to try new ways of working',
        title_360_workenv: 'new things can be tried',
        preferredType: 'leadership',
    },
    {
        id: 38,
        valueKey: 'innovatie2',
        title: 'One has many new experiences',
        title_360_leadership: 'encourages us to gain new experiences',
        title_360_workenv: 'one has many new experiences',
        preferredType: 'workenv',
    },
    {
        id: 39,
        valueKey: 'innovatie3',
        title: 'Challenges can be sought',
        title_360_leadership: 'stimulates us to seek new challenges',
        title_360_workenv: 'challenges can be sought',
        preferredType: 'leadership',
    },
    {
        id: 40,
        valueKey: 'daadkracht1',
        title: 'One takes initiative to tackle tasks',
        title_360_leadership: 'encourages us to take the initiative on tasks',
        title_360_workenv: 'one takes initiative to tackle tasks',
        preferredType: 'workenv',
    },
    {
        id: 41,
        valueKey: 'daadkracht2',
        title: 'We make sure we get results',
        title_360_leadership: "ensures that results are achieved",
        title_360_workenv: 'we make sure we get results',
        preferredType: 'leadership',
    },
    {
        id: 42,
        valueKey: 'daadkracht3',
        title: 'Every possible effort is made to achieve the set objectives',
        title_360_leadership:
            'does everything to achieve the targeted goals',
        title_360_workenv:
            'every possible effort is made to achieve the set objectives',
        preferredType: 'leadership',
    },
]

export const extra360En_EnStatements : (Omit<STM, 'title'>)[] = [
    // Additional statements used in Actual360 but not IdealClassic
    {
      id: 43,
      valueKey: 'daadkracht4',
      title_360_leadership:
          'makes decision',
      preferredType: 'leadership',
    },
    {
      id: 44,
      valueKey: 'gelijk4',
      title_360_leadership:
          'respect and values differences between team members',
      preferredType: 'leadership',
    },
    {
      id: 45,
      valueKey: 'prestatie4',
      title_360_leadership:
          'gives constructive feedback',
      preferredType: 'leadership',
    },
]
